import React from 'react';
import { FIELD_NAMES, FIELD_TYPES } from 'utils/constants';
import FieldEditorBoolean from '../FieldEditors/FieldEditorBoolean';
import FieldEditorDegreeOffering from '../FieldEditors/FieldEditorDegreeOffering';
import FieldEditorDropdown from '../FieldEditors/FieldEditorDropdown';
import FieldEditorMultiPicklist from '../FieldEditors/FieldEditorMultiPicklist';
import FieldEditorGDPRConsent from '../FieldEditors/FieldEditorGDPRConsent';
import FieldEditorNonEditable from '../FieldEditors/FieldEditorNonEditable';
import FieldEditorOptIn from '../FieldEditors/FieldEditorOptIn';
import FieldEditorText from '../FieldEditors/FieldEditorText';

export function FactoryErrorState(selectorHints) { return () => (<div className="mt-5">No editor found for type [{selectorHints.type}]</div>); }

export function Factory(selectorHints) {
  switch (selectorHints.type) {
    case FIELD_TYPES.RADIO_BUTTON:
      return FieldEditorBoolean;
    case FIELD_TYPES.COUNTRY:
      return FieldEditorNonEditable('Country');
    case FIELD_TYPES.DEGREE_OFFERING:
      return FieldEditorDegreeOffering;
    case FIELD_TYPES.DROPDOWN:
      return FieldEditorDropdown;
    case FIELD_TYPES.MULTIPICKLIST:
      return FieldEditorMultiPicklist;
    case FIELD_TYPES.OPTIN:
    case FIELD_TYPES.PICKLIST_VALUE_OPT_IN:
    case FIELD_TYPES.BOOLEAN_OPT_IN:
    case FIELD_TYPES.NON_GDPR_CONSENT:
      return FieldEditorOptIn;
    case FIELD_TYPES.GDPR_CONSENT:
      return FieldEditorGDPRConsent;
    case FIELD_TYPES.NATIONALITY:
      return FieldEditorNonEditable('Nationality');
    case FIELD_TYPES.RADIO_BUTTONS:
      return FieldEditorText;
    case FIELD_TYPES.STATE:
      return FieldEditorNonEditable('State');
    case (FIELD_TYPES.TEXT):
      // This is to migrate existing text phone fields to the new phone field editor
      if (selectorHints.name === FIELD_NAMES.PHONE) return FieldEditorNonEditable('Phone');
      // This is to migrate existing text email fields to the new email field editor
      if (selectorHints.name === FIELD_NAMES.EMAIL) return FieldEditorNonEditable('Email');
      return FieldEditorText;
    case FIELD_TYPES.PHONE:
      return FieldEditorNonEditable('Phone');
    case FIELD_TYPES.EMAIL:
      return FieldEditorNonEditable('Email');
    default:
      return FactoryErrorState(selectorHints);
  }
}

export default Factory;
